export default "__VITE_PUBLIC_ASSET__bc7f6153__"